
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite';

import CollabWorkSpace from 'components/CollabWorkSpace';

import useUserIdentity from 'hooks/useUserIdentity';
import useCollabs from 'hooks/useCollabs';


const SupportWorkspace = observer(() => {
	const { collabKey = "" } = useParams<{ collabKey: string }>();
    const { getCollab, fetchCollab, collabs } = useCollabs();

    const { currentIdentity } = useUserIdentity();
    const [collab, setCollab] = useState(getCollab(collabKey));

    useEffect(() => {
        if(!currentIdentity?.key) {
            return;
        }
        if (!collab || (collab && collab.uuid !== collabKey)) {
            console.log("fetching collab", collabKey);
            /* This doesn't return a promise, so just call it */
            fetchCollab(currentIdentity.key, collabKey);
        }
    }, [collab, collabKey, currentIdentity.key]);

    useEffect(() => {
        /* Set our collab after it loads. Most likely from collabs.length changing */
        const collab = getCollab(collabKey);
        setCollab(collab);
        console.log("fetching, got collab", collab);
    }, [collabKey, getCollab, setCollab, collabs.length]);


    return (
       <CollabWorkSpace collabKey={collabKey} />
    );
});

export default SupportWorkspace;
